import React from "react";
import styled from "styled-components";
import { parseBoldSegments } from "components/global/typography/parseFormattedText.js";

const Bold = styled.span`
  font-weight: 700;
`;

function TextWithLineBreaks(props) {
  if (typeof props.text !== "string") {
    return null;
  }

  const renderLine = (line, lineIndex) =>
    parseBoldSegments(line).map((segment, segmentIndex) => {
      const key = `line-${lineIndex}-seg-${segmentIndex}`;

      if (segment.bold) {
        return <Bold key={key}>{segment.text}</Bold>;
      }

      return (
        <React.Fragment key={key}>{segment.text}</React.Fragment>
      );
    });

  const textWithBreaks = props.text.split("\n").map((line, index, array) => (
    <React.Fragment key={index}>
      {renderLine(line, index)}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));

  return <>{textWithBreaks}</>;
}

export default TextWithLineBreaks;
